import PasswordChangeForm from '../component/form/PasswordChangeForm'
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'

const PasswordChangeDialog = (props)=>{

  const onSubmit = (row) => {
    props.process(row);
    close();
  };

  const close = () => {
    props.setOpen(false);
  }

  const submit = (data) =>{
    props.process(data);
    close();
  }



  return (
    <>
      <Dialog open={props.open} onClose={close} maxWidth={"sm"} sx={{}}>
        <DialogContent>
          <PasswordChangeForm process={onSubmit} current={false} />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default PasswordChangeDialog;